import * as constantes from "../constants/constantes.js";
const ENDPOINT = constantes.URLAPI;

export const ObtenerProgresoCursoPorPersonaCurso = async({jwt,idPersonaCurso})=> {
    return await fetch(`${ENDPOINT}/ZADCurso/ObtenerProgresoCursoPorPersonaCurso/${idPersonaCurso}`,{
    //return await fetch(`${ENDPOINTTEST}/ObtenerProgresoCursoPorPersonaCurso/${idPersonaCurso}`,{
        method: "GET",
        headers:{
            "Authorization":"Bearer "+jwt,
            //'Content-Type': 'application/json'
            "accept": "text/plain"
        },
        
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
    
}

export const RegistrarProgresoCurso= ({jsonProgreso,jwt}) =>{
    //return fetch(`${ENDPOINTTEST}/RegistrarProgresoCurso`,{
    return fetch(`${ENDPOINT}/ZADCurso/RegistrarProgresoCurso`,{
        method: "POST",
        headers:{
            "Authorization":"Bearer "+jwt,
            'Content-Type': 'application/json',
            "accept": "application/json"
        },
        
        body: jsonProgreso
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}

export const ActualizarProgresoCurso= ({jsonProgreso,jwt}) =>{
    //return fetch(`${ENDPOINTTEST}/ActualizarProgresoCurso`,{
    return fetch(`${ENDPOINT}/ZADCurso/ActualizarProgresoCurso`,{
        method: "POST",
        headers:{
            "Authorization":"Bearer "+jwt,
            'Content-Type': 'application/json',
            "accept": "application/json"
        },
        
        body: jsonProgreso
    }).then(res=>{
        //if(!res.ok) throw new Error("Response is Not Ok")
        if(!res.ok) 
        {
            if(res.status == 401)
            {
                window.localStorage.removeItem('jwt')
                window.location.reload();
            }
            else
            {
                throw new Error("No se recibió respuesta del servidor")
            }
        }
        return res.json()
    }).then(res=>{
        if(res.errors) throw new Error(res.errors[0])
        const {data} = res
        return data
    })
}